module.exports = __webpack_public_path__ + "static/media/easy-cafeteria.89e24bdb.png";